import * as React from 'react';

import {ActivityListItem} from 'shells/list-item/activity-list-item';
import {ListView} from 'shells/list-view/list-view';

import styles from './overdue-activities.module.css';

type Props = {
    userId: string;
    activities: {
        id: string;
        type: string;
        name: string;
        htmlUrl: string;
        startTime: number;
        endTime: number;
        isLogged: boolean;
        isAllDay: boolean;
        isLastDay?: boolean;
        isOverdue: boolean;
        isFlagged?: boolean;
        agenda: string;
        participants: any[];
    }[];
    onStartEmailToParticipant: (entityId: string) => any;
    onStartCallToParticipant: (arg1: {
        entityId: string;
        phoneNumber: {
            E164: string;
            numberFormatted: string;
        };
        anchorElementId: string;
    }) => void;
};

export class OverdueActivities extends React.Component<Props> {
    render() {
        const loadedActivities = this.props.activities.filter((activity) => {
            return activity.name;
        });

        return (
            <div className={styles.list}>
                <ListView
                    collection={loadedActivities}
                    renderRow={(activity) => {
                        return (
                            <ActivityListItem
                                key={activity.id}
                                showRichTimestamp={true}
                                userId={this.props.userId}
                                activity={activity}
                                onStartCallToParticipant={this.props.onStartCallToParticipant}
                                onStartEmailToParticipant={this.props.onStartEmailToParticipant}
                            />
                        );
                    }}
                />
            </div>
        );
    }
}
